import { useNavigation } from "@react-navigation/native";
import React from "react";
import { ImageBackground, Pressable, StyleSheet, View } from "react-native";
import Text from "@components/AppText";
import { scale, verticalScale } from "../../utils/scale";
import WhatsappDefault from "@assets/svg/WhatsappDefault";
import { colors } from "@constants/theme";
import { isSmallScreen } from "@constants/metrics";
import useShopShare from "@hooks/useShopShare";

const ShopShareBanner = ({ cl_title, cl_subtitle, image_link }) => {
  const [handleShopShare] = useShopShare();

  return (
    <Pressable>
      <ImageBackground source={{ uri: image_link }} style={styles.topContainer}>
        <View style={[styles.itemAsRow, { marginTop: verticalScale(5) }]}>
          <Text
            style={{
              fontWeight: "bold",
              fontSize: scale(16),
              alignSelf: "flex-end",
              marginBottom: verticalScale(5),
            }}
          >
            {cl_title || ""}
          </Text>
        </View>
        <View style={styles.itemAsRow}>
          <Text
            style={{
              fontSize: scale(14),
              paddingRight: scale(10),
              flex: 1,
            }}
          >
            {cl_subtitle || ""}
          </Text>
          <Pressable
            onPress={handleShopShare}
            style={styles.whatsappButtonStyles}
          >
            <WhatsappDefault />
            <Text
              fontType={isSmallScreen ? "content2" : "content1"}
              style={[styles.messageKare, { fontWeight: "bold" }]}
            >
              शॉप शेयर करें
            </Text>
          </Pressable>
        </View>
      </ImageBackground>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  topContainer: {
    width: scale(345),
    alignSelf: "center",
    height: verticalScale(100),
    borderRadius: scale(6),
    alignSelf: "center",
    overflow: "hidden",
    paddingVertical: verticalScale(10),
  },
  itemAsRow: {
    marginHorizontal: scale(20),
    flexDirection: "row",
  },
  messageKare: {
    color: colors.white,
    paddingLeft: 6,
    paddingRight: 2,
  },
  whatsappButtonStyles: {
    marginLeft: "auto",
    backgroundColor: "#23CF5F",
    flexDirection: "row",
    borderRadius: 6,
    paddingVertical: 6,
    paddingHorizontal: 11,
    height: verticalScale(40),
    width: scale(135),
    justifyContent: "center",
    alignItems: "center",
  },
});

export default ShopShareBanner;
